import { Controller } from "@hotwired/stimulus"

// Pings the presence endpoint on a fixed interval while the tab is visible, so an
// idle-but-open user keeps last_seen_at fresh and is treated as "present" (no absence email).
// A backgrounded/hidden tab stops pinging, so it correctly stops counting as present.
export default class extends Controller {
  static values = { url: String, interval: { type: Number, default: 60000 } }

  connect() {
    this.ping = this.ping.bind(this)
    this.timer = setInterval(this.ping, this.intervalValue)
    document.addEventListener("visibilitychange", this.ping)
  }

  disconnect() {
    clearInterval(this.timer)
    document.removeEventListener("visibilitychange", this.ping)
  }

  ping() {
    if (document.visibilityState !== "visible") return

    const token = document.querySelector('meta[name="csrf-token"]')?.content
    fetch(this.urlValue, {
      method: "POST",
      headers: { "X-CSRF-Token": token, "Accept": "application/json" },
      credentials: "same-origin",
      keepalive: true,
    }).catch(() => {})
  }
}
